import {
	AcceptanceStatus,
	CustomDetailCategory,
	DocumentWorkflowInstanceSignatureStatus,
	SubjectAction,
} from '@dealstack/shared/lib/generated';
import { isConcludedSignatureStatus } from '@dealstack/shared/lib/common/business/signatureStatus';

export interface FormReviewCardData {
	templateId: string;
	templateName: string;
	templateFileId: string | null;
	isSmartForm: boolean;
	status: AcceptanceStatus | null;
	fileId: string | null;
	fileName: string | null;
	rejectionComment: string | null;
	subjectAction: SubjectAction | null;
	createdAt: string | null;
	instanceId: string | null;
	requiresSignature: boolean;
	signatureStatus: DocumentWorkflowInstanceSignatureStatus | null;
}

export type SelectedTemplate = FormReviewCardData;

export interface FormCategoryGroup {
	key: string;
	category: CustomDetailCategory | null;
	title: string;
	cards: FormReviewCardData[];
}

export const isFormSubmitted = (form: { status: AcceptanceStatus | null }): boolean =>
	form.status !== null;

/**
 * A signing form still waiting on its investor. Approving is allowed from here — it terminates the
 * signature request — so this drives the warning, not a disabled button. `isConcludedSignatureStatus`
 * so a slot a previous approval already closed stops reading as outstanding.
 */
export const isAwaitingRequiredSignature = (form: {
	requiresSignature: boolean;
	signatureStatus: DocumentWorkflowInstanceSignatureStatus | null;
}): boolean => form.requiresSignature && !isConcludedSignatureStatus(form.signatureStatus);
